import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import qs from "qs";
import * as Yup from "yup";
import { useForm } from "react-yup";
import { Select } from "~/ui";

interface QueryParams {
  show?: Filter;
}

type Filter = "all" | "opp" | "org";

export const FavouriteInlineSelectForm: React.FC<
  React.HTMLAttributes<HTMLFormElement>
> = (props) => {
  const location = useLocation();
  const { replace } = useHistory();

  const currentQuery = React.useMemo<QueryParams>(() => {
    return qs.parse(location.search, { ignoreQueryPrefix: true });
  }, [location.search]);

  const { FormProvider, field, values, setValue } = useForm({
    validationSchema: Yup.object({
      filter: Yup.string().nullable(),
    }),
    defaultValues: {
      filter: currentQuery.show || "all",
    },
  });

  React.useEffect(() => {
    setValue("filter", location.search.split("=").pop() || "all");
  }, [location.search, setValue]);

  const handleChangeFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const name = "show";
    const nextQuery: QueryParams = { ...currentQuery };

    if (e.target.value === "all") {
      delete nextQuery[name];
    } else {
      nextQuery[name] = e.target.value as Filter;
    }

    replace({
      pathname: location.pathname,
      search: qs.stringify(nextQuery),
    });
  };

  return (
    <FormProvider>
      <form {...props}>
        <Select
          {...field}
          id="filter"
          name="filter"
          label="Filter by"
          labelProps={{
            className: "sr-only",
          }}
          selectProps={{
            className: "mt-0",
          }}
          optional
          value={values.filter as string}
          onChange={handleChangeFilter}
        >
          <option value="all">All favourites</option>
          <option value="opp">Opportunities</option>
          <option value="org">Organisations</option>
        </Select>
      </form>
    </FormProvider>
  );
};
